<template>
    <div class="bindPhone">
        <navtop v-bind:index="'bindPhone'"></navtop>
        <div class="con" v-if="!hasBindPhone">
            <input
                class="phoneNum"
                type="number"
                placeholder="请输入手机号"
                v-model="phone"
            />
            <div class="imgCodeWrap">
                <input
                    class="imgCodeNum"
                    type="text"
                    placeholder="请输入图形验证码"
                    v-model="yzImg"
                />
                <img
                    class="codeImg"
                    v-bind:src="yzImgSrc"
                    v-on:click="yzImgSrc = yzImgSrc + '&v=' + Math.random()"
                />
            </div>
            <div class="codeWrap">
                <input
                    class="codeNum"
                    type="number"
                    placeholder="请输入手机验证码"
                    v-model="code"
                />
                <p
                    v-on:click="getCode"
                    v-bind:disabled="!(phoneState && yzImgState & timer)"
                >
                    {{ timerstr }}
                </p>
            </div>
            <input
                class="password"
                type="password"
                placeholder="请输入六位以上密码(可包含数字、字母或./-)"
                v-model="password"
            />
            <div
                class="bindBtn"
                v-on:click="toBind"
                v-bind:disabled="!(phoneState && codeState && passwordState)"
            >
                绑定
            </div>
        </div>
        <div class="hasBind" v-if="hasBindPhone">
            <p class="phone">
                {{ hasBindPhone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3") }}
            </p>
            <p class="des">绑定手机号可用于此账号登录</p>
            <div class="changeBtn" v-on:click="toChangePhone">更改</div>
        </div>
    </div>
</template>

<script>
import navtop from "../dating/navTop";
import cookie from "../../libs/cookie";
import { mapState } from "vuex";
export default {
    name: "index",
    data() {
        return {
            phone: "", //手机号
            yzImg: "", //图形码
            code: "", //验证码
            password: "", //密码
            phoneState: false, //手机校验
            yzImgState: false, //图形码校验
            codeState: false, //验证码校验
            passwordState: false, //密码校验
            tips: "",
            popTips: false,
            yzImgSrc: "https://login-m.qxiu.com/verify/codeImage?size=200x70",
            timer: true,
            timerstr: "获取验证码",
            hasBindPhone: "",
        };
    },
    components: {
        navtop,
    },
    computed: mapState(["channelID", "sourceType", "forceLogin"]),
    mounted() {
        this.checkBind();
    },
    methods: {
        checkBind() {
            var _this = this;
            $.ajax({
                type: "get",
                url:
                    "https://login-m.qxiu.com/cgi/login/listbinds?oemid=43&uid=" +
                    cookie.get("uid") +
                    "&mcheck=" +
                    cookie.get("mcheck"), //小熊版本oemid必填
                async: true,
                dataType: "jsonp",
                success: function (res) {
                    if (res.state == 0 && res.content) {
                        for (var i = 0; i < res.content.length; i++) {
                            if (res.content[i].bindType == "phone") {
                                _this.hasBindPhone =
                                    res.content[i].bindId.slice(3);
                            }
                        }
                    } else if (res.message) {
                        toast(res.message);
                    }
                },
            });
        },
        toChangePhone() {
            toast("请下载小熊直播客户端 <br>更改绑定手机号");
        },
        getCode() {
            var _this = this;
            if (!this.timer) {
                return;
            }
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                toast("请输入正确的手机号");
                return;
            } else if (!/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
                toast("请输入正确的图形验证码");
                return;
            } else {
                _this.yzImgSrc = _this.yzImgSrc + "&v=" + Math.random();

                $.ajax({
                    type: "get",
                    url:
                        "https://login-m.qxiu.com/cgi/web/login/phone/sendCode?oemid=43&phone=" +
                        _this.phone +
                        "&code=" +
                        _this.yzImg.toUpperCase(), //小熊版本oemid必填
                    async: true,
                    dataType: "jsonp",
                    success: function (res) {
                        if (res.state == 0 && res.content.sendState == true) {
                            var time = 60;
                            _this.timer = false;
                            var interval = setInterval(function () {
                                _this.timerstr = time + "s";
                                time--;
                                if (time == 0) {
                                    clearInterval(interval);
                                    _this.timer = true;
                                    _this.timerstr = "获取验证码";
                                }
                            }, 1000);
                            toast("验证码发送成功");
                        } else if (res.message) {
                            toast(res.message);
                        }
                    },
                });
            }
        },
        toBind() {
            var _this = this;
            if (!/^1[234578]\d{9}$/.test(this.phone)) {
                toast("请输入正确的手机号");
                return;
            } else if (!/^\d{6}$/.test(this.code)) {
                toast("请输入正确的短信验证码");
                return;
            } else if (!/^[\d a-z A-Z \- \. \/]{6,}$/.test(this.password)) {
                toast("请输入正确的密码");
                return;
            } else {
                $.ajax({
                    type: "get",
                    url:
                        "https://login-m.qxiu.com/cgi/login/bindPhone?oemid=43&uid=" +
                        cookie.get("uid") +
                        "&mcheck=" +
                        cookie.get("mcheck") +
                        "&phone=" +
                        _this.phone +
                        "&code=" +
                        _this.code +
                        "&password=" +
                        _this.password +
                        "&thirdNick=" +
                        _this.phone, //小熊版本oemid必填
                    async: true,
                    dataType: "jsonp",
                    success: function (res) {
                        if (res.state == 0) {
                            toast("绑定成功", function () {
                                _this.checkBind();
                            });
                        } else if (res.state == 200501) {
                            toast("您输入的手机号已绑定或注册请更换手机号");
                        } else if (res.message) {
                            toast(res.message);
                        }
                    },
                });
            }
        },
    },
    watch: {
        phone() {
            if (this.phone.length > 11) {
                this.phone = this.phone.slice(0, 11);
            }
            if (/^1[234578]\d{9}$/.test(this.phone)) {
                this.phoneState = true;
            } else {
                this.phoneState = false;
            }
        },
        yzImg() {
            if (/^[\d a-z A-Z]{4}$/.test(this.yzImg)) {
                this.yzImgState = true;
            } else {
                this.yzImgState = false;
            }
        },
        code() {
            if (/^\d{6}$/.test(this.code)) {
                this.codeState = true;
            } else {
                this.codeState = false;
            }
        },
        password() {
            if (/^[\d a-z A-Z \- \. \/]{6,}$/.test(this.password)) {
                this.passwordState = true;
            } else {
                this.passwordState = false;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bindPhone .con,
.bindPhone .hasBind {
    position: absolute;
    top: 2.2rem;
    bottom: 0;
    width: 100%;
    background: #fff;
    text-align: center;
}

.bindPhone .con input {
    width: 10.64rem;
    height: 1.8rem;
    padding-left: 0.4rem;
    background: #f5f5f5;
    border-radius: 0.2rem;
    outline: none;
    border: none;
    font-size: 0.52rem;
}
.bindPhone .con input::-webkit-input-placeholder {
    color: #cccccc;
}

.bindPhone .con .phoneNum {
    float: left;
    margin: 2.26rem 0 0.64rem 2.1rem;
}

.codeWrap,
.imgCodeWrap {
    float: left;
    overflow: hidden;
}

.bindPhone .con .codeNum,
.imgCodeWrap input.imgCodeNum {
    float: left;
    width: 6.9rem;
    margin-left: 2.1rem;
    margin-bottom: 0.64rem;
}

.codeWrap p,
.codeImg {
    float: left;
    width: 3.88rem;
    height: 1.8rem;
    background: #8d49e5;
    vertical-align: middle;
    line-height: 1.8rem;
    color: #fff;
    font-size: 0.52rem;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}
.codeWrap p[disabled] {
    color: #fff;
    border-color: #ccc;
    background: #ccc;
}

.bindBtn {
    position: absolute;
    top: 13rem;
    left: 2.06rem;
    width: 10.96rem;
    height: 1.8rem;
    background: linear-gradient(to right, #ff76dd, #913aee);
    border-radius: 0.9rem;
    line-height: 1.8rem;
    font-size: 0.56rem;
    color: #fff;
}
.bindBtn[disabled] {
    background: #ccc;
}
.canNotReceiveCode {
    position: absolute;
    top: 11.54rem;
    width: 100%;
    font-size: 0.48rem;
    color: #8d49e5;
}

.bindPhone .hasBind .phone {
    margin: 3.1rem 0 1rem;
    font-size: 0.72rem;
    color: #333;
}
.bindPhone .hasBind .des {
    font-size: 0.52rem;
    color: #ccc;
}
.bindPhone .hasBind .changeBtn {
    width: 10.96rem;
    height: 1.8rem;
    margin: 3.5rem auto 0;
    background: linear-gradient(to right, #ff76dd, #913aee);
    border-radius: 0.9rem;
    line-height: 1.8rem;
    font-size: 0.56rem;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// bindPhone.vue?486210df